import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a7b28d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeview" }
const _hoisted_2 = { class: "leftcontent" }
const _hoisted_3 = {
  key: 0,
  class: "bigbox flex v-center center"
}
const _hoisted_4 = {
  key: 1,
  class: "activitybox flex column"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex column grow-1" }
const _hoisted_7 = { class: "flex gap" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = {
  key: 0,
  class: "flex alert"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gg-danger" }, null, -1))
const _hoisted_13 = { class: "copy" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gg-check big check" })
], -1))
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "rightcontent" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NEXT", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_selector = _resolveComponent("activity-selector")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_currency = _resolveComponent("currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_activity_selector, {
      validate: "time",
      onOnChange: _ctx.update
    }, null, 8, ["onOnChange"]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { package: _ctx.isPackage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.activity?.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_loader_display)
            ]))
          : (_ctx.times.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (time) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["ratebox flex v-center", { selected: _ctx.isSelected(time) }]),
                    key: time.OrderEntityTimeKey ?? 0,
                    onClick: ($event: any) => (_ctx.select(time))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(time.DisplayName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createTextVNode("Subtotal: "),
                          _createVNode(_component_currency, {
                            amount: time.SubTotal
                          }, null, 8, ["amount"])
                        ])
                      ])
                    ]),
                    (_ctx.warningFor(time))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.warningFor(time)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_14
                  ], 10, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createTextVNode(" There are no available times for " + _toDisplayString(_ctx.activity?.name) + " on " + _toDisplayString(_ctx.format(_ctx.activity?.selectedDate ?? new Date(), 'eeee, MMM d')) + ". ", 1),
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/portal/${_ctx.clientLocationKey}/${_ctx.type}/${_ctx.typekey}/book/date`))),
                  class: "biglink"
                }, "Pick a different date")
              ]))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: _normalizeClass(["bookbutton", { broken: !_ctx.canProceed }]),
          onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]))
        }, _hoisted_21, 34)
      ])
    ], 2)
  ]))
}